import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import PrintLabels from "../../components/generics/PrintLabels";
import Spinner from "../../components/generics/Spinner";
import LabelList from "../../components/invoices/LabelList";

import {
  fetchBoxes,
  fetchBoxesSuccess,
  fetchBoxesFailure,
  fetchInvoice,
  fetchInvoiceSuccess,
  fetchInvoiceFailure,
} from "../../store/invoices/actions";
import { withRouter } from "utils/WithRouter";

export class LabelsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      boxes: [],
    };
  }

  componentDidMount() {
    this.props.fetchInvoice(this.props.match.params.id);
    this.props.fetchBoxes(this.props.match.params.id);
  }

  printAll = () => {
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    for (var i = 0; i < this.state.boxes.length; i++) {
      if (!this.state.boxes[i].itemIsBarcode) {
        var content = document.getElementById("toPrint" + i);
        pri.document.write(content.innerHTML);
      }
    }
    pri.document.close();
    setTimeout(() => {
      pri.focus();
      pri.print();
    }, 50);
  };

  printLabel = (index) => {
    var content = document.getElementById("toPrint" + index);
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    setTimeout(() => {
      pri.focus();
      pri.print();
    }, 50);
  };

  componentDidUpdate(prevProps) {
    // if this happens, it means we're editing an invoice
    if (prevProps.boxesList.boxes.length < this.props.boxesList.boxes.length) {
      let is_inventory_control = [];
      this.props.boxesList.boxes.forEach((box) => {
        if (box.item.is_inventory_control) {
          is_inventory_control.unshift(box);
        }
      });

      is_inventory_control = _.orderBy(
        is_inventory_control,
        ["timestamp_label_created"],
        ["asc"]
      );

      this.setState({
        boxes: is_inventory_control.map((box) => {
          const has_grade = box.extra_info
            ? box.extra_info.grade
              ? true
              : false
            : false;
          return {
            id: box.id,
            item_id: box.item.id,
            item: box.item.name,
            itemIsBarcode: box.item.is_barcode_item,
            category: box.category.category_name,
            brand: box.brand.brand_name,
            brand_id: box.brand.id,
            station: box.station.name,
            station_id: box.station.id,
            lot: box.vendor_lot_number,
            weight: box.weight,
            pieces: box.number_items,
            price: box.price,
            packingDate: box.packing_date,
            expiration_date: box.expiration_date,
            has_grade: has_grade,
            grade: has_grade ? box.extra_info.grade.grade : undefined,
            grade_id: has_grade ? box.extra_info.grade.id : undefined,
            allergies: box.item.allergies ? box.item.allergies : undefined,
          };
        }),
      });
    }
  }

  render() {
    if (this.props.boxesList.loading || this.props.invoiceDetail.loading) {
      return <Spinner />;
    }
    let styleFrame = {
      height: "0px",
      width: "0px",
      position: "absolute",
    };
    return (
      <div className="labels-list">
        <div className="container-fluid">
          <div className="animated fadeIn">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <span>
                  <i className="fa fa-edit"></i>
                  <span className="ml-05">Label List</span>
                </span>
                <button
                  type="button"
                  className="btn btn-primary m-0"
                  onClick={this.printAll}
                >
                  Print All
                </button>
              </div>
              <div className="card-block p-0">
                <table className="table table-striped table-bordered datatable mb-0">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th className="hidden-xxs-down">Vendor</th>
                      <th className="hidden-xs-down">Brand</th>
                      <th className="hidden-xs-down">Packing Date</th>
                      <th>Item</th>
                      <th className="hidden-xs-down">Weight</th>
                      <th className="hidden-xs-down">Pieces</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <LabelList
                    invoice={this.props.invoiceDetail.invoice}
                    boxes={this.state.boxes}
                    printLabel={this.printLabel}
                  />
                </table>
              </div>
            </div>
          </div>
        </div>

        {this.state.boxes.map((box, index) => {
          return (
            !box.itemIsBarcode && (
              <div id={index} key={index}>
                <PrintLabels
                  invoice={this.props.invoiceDetail.invoice}
                  box={box}
                  index={index}
                  printLabel={this.printLabel}
                />
              </div>
            )
          );
        })}
        <iframe id="ifmcontentstoprint" style={styleFrame}></iframe>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    boxesList: state.invoices.boxesList,
    invoiceDetail: state.invoices.invoiceDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoice: (iId) => {
      dispatch(fetchInvoice(iId)).payload.then(
        (response) => {
          dispatch(fetchInvoiceSuccess(response.data));
        },
        (error) => {
          dispatch(fetchInvoiceFailure(error));
        }
      );
    },
    fetchBoxes: (cId, dataBox) => {
      dispatch(fetchBoxes(cId, dataBox)).payload.then(
        (response) => {
          dispatch(fetchBoxesSuccess(response.data));
        },
        (error) => {
          dispatch(fetchBoxesFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LabelsContainer));
